import * as kiwiSdk from "@huyafed/huya-kiwi";
import { createRoot } from "react-dom/client";
import App from "./App";
import { tafFetch } from "./api/_tafFetch";
import { CURRENT_ENV } from "./utils/env";
import logger from "./utils/logger";

const logRuntimeInitializationError = (error: unknown) => {
  const message = "[GameToolRuntime] initialization failed";
  try {
    logger.error(message, { error });
  } catch (loggerError) {
    console.warn("[GameToolRuntime] SDK logger failed:", loggerError);
  }
  console.warn(`${message}:`, error);
};

try {
  void window.GameToolRuntime
    ?.init({
      gameId: import.meta.env.VITE_GAME_ID,
      toolId: import.meta.env.VITE_TOOL_ID,
      env: CURRENT_ENV,
      tafFetch,
      sdk: kiwiSdk,
    })
    .catch(logRuntimeInitializationError);
} catch (error) {
  logRuntimeInitializationError(error);
}

createRoot(document.getElementById("root")!).render(<App />);
